export default "__VITE_ASSET__BhW7H_gT__"